import React, { Fragment, useEffect, useReducer } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import ai from "../../helpers/axios";
import columns from "./click-to-fly-results-columns";
import Search from "../search";
import DataTableServerPagination from "../data-table-server-pagination";
import PageHeaderRowSearch from "../shared/page-header-row-search";
import "./click-to-fly-results.css";

const reducer = (state, action) => {
  switch (action.type) {
    case "search": {
      return {
        ...state,
        query: action.query,
      };
    }
    case "dataBeganDownloading": {
      return {
        ...state,
        loading: action.payload.loadingStatus,
      };
    }
    case "dataDownloaded": {
      return {
        ...state,
        results: {
          data: action.payload.data.results,
        },
        loading: false,
        totalLength: action.payload.data.countTotal,
      };
    }
    case "pageChanged": {
      return {
        ...state,
        currentPage: action.payload.page,
      };
    }
    case "tableSort": {
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortDirection: action.payload.sortDirection,
      };
    }
    case "rowsPerPageChanged": {
      return {
        ...state,
        countPerPage: action.payload.currentRowsPerPage,
      };
    }
    default:
      break;
  }
  return state;
};

const ClickToFlyResultsContent = () => {
  const initialState = {
    results: {
      data: [],
    },
    loading: true,
    countPerPage: 25,
    currentPage: 1,
    totalLength: null,
    query: "",
    sortDirection: "desc",
    sortBy: "createdAt",
  };

  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const [state, dispatch] = useReducer(reducer, initialState);

  const getData = async (dbQuery, loadSilently, sortBy, sortDirection) => {
    let loadingStatus = true;
    if (loadSilently) {
      loadingStatus = false;
    }

    dispatch({ type: "dataBeganDownloading", payload: { loadingStatus } });

    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    let { data } = await ai.auth(token).get(`/api/clickToFly/results/list`, {
      params: {
        query: dbQuery,
        page: state.currentPage,
        countPerPage: state.countPerPage,
        sortBy,
        sortDirection,
      },
    });

    dispatch({
      type: "dataDownloaded",
      payload: {
        data,
      },
    });
  };

  useEffect(() => {
    getData(state.query, false, state.sortBy, state.sortDirection);
    document.title = "ClickToFly Results | evoJets HQ";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.currentPage, state.countPerPage]);

  const handlePageChange = (page, totalRows) => {
    dispatch({
      type: "pageChanged",
      payload: {
        page,
        totalRows,
      },
    });
  };

  const handleRowsPerPageChange = (currentRowsPerPage, currentPage) => {
    dispatch({
      type: "rowsPerPageChanged",
      payload: {
        currentRowsPerPage,
        currentPage,
      },
    });
  };

  const handleSearch = (e) => {
    let query = e.target.value.toLowerCase();

    dispatch({ type: "search", query });
    getData(query, true, state.sortBy, state.sortDirection);
  };

  const handleSort = (column, sortDirection) => {
    dispatch({
      type: "tableSort",
      payload: {
        sortBy: column.selector,
        sortDirection,
      },
    });

    getData(state.query, true, column.selector, sortDirection);
  };

  return (
    <Fragment>
      <PageHeaderRowSearch
        h1="ClickToFly Results"
        pretitle="Business"
        breadcrumbs={[
          { link: "/click-to-fly", label: "ClickToFly Hub" },
          { link: "/click-to-fly/results", label: "Results" },
        ]}
        rightColumn={
          <div id="quote-actions-row">
            <Search
              onSearch={handleSearch}
              placeholder="Search by route..."
              query={state.query}
              className="lead-search"
            ></Search>
          </div>
        }
      ></PageHeaderRowSearch>

      <DataTableServerPagination
        columns={columns}
        handlePageChange={handlePageChange}
        handleRowsPerPageChange={handleRowsPerPageChange}
        state={state}
        data={state.results.data}
        defaultSortField={"createdAt"}
        defaultSortAsc={false}
        handleSort={handleSort}
        sortServer={true}
      ></DataTableServerPagination>
    </Fragment>
  );
};

export default ClickToFlyResultsContent;

